export const NAVIGATION_ITEMS_PAGE_SIZE = 75;
